import Card from "antd/es/card/Card";
import CoverageCategories from "entities/CoverageCategory";
import { isEmpty } from "lodash";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { MdAdd } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import Header from "shared/components/Header";
import Search from "shared/components/Input";
import { NAME_SPACES } from "shared/locales/constants";
import { INITIAL_VALUES, SCREENS } from "utils/constants";
import View from "./View";

const List = () => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.COVERAGE_CATEGORY);
  const LIST = t("LIST", { returnObjects: true });
  const [pagination, setPagination] = useState({});
  const [search, setSearch] = useState("");
  const filter = {
    ...INITIAL_VALUES,
    like: isEmpty(search)
      ? undefined
      : {
          OR: [{ label: `%${search}%` }],
        },
  };
  const navigate = useNavigate();

  const buttons = [
    // {
    //   type: "primary--outlined",
    //   icon: <MdLineWeight size={24} />,
    //   text: LIST.HEADER.CATEGORIES_WEIGHT,
    //   onClick: () =>
    //     navigate(SCREENS.PRIVATE.ADMIN.COVERAGE_CATEGORIES.WEIGHT.path),
    // },
    {
      icon: <MdAdd size={24} />,
      text: LIST.HEADER.SAVE,
      onClick: () =>
        navigate(SCREENS.PRIVATE.ADMIN.COVERAGE_CATEGORIES.CREATE.path, {
          state: { ...filter, ...pagination },
        }),
    },
  ];

  return (
    <>
      <Header title={LIST.HEADER.TITLE} actions={buttons} />
      <Card type="simple">
        <div className="m-bottom-20 grid--4">
          <Search
            placeholder={LIST.SEARCH}
            type="search"
            onChange={({ target: { value } }) => {
              setPagination((prev) => ({ ...prev, skip: 0 }));
              setSearch(value);
            }}
          />
        </div>
        <CoverageCategories
          View={View}
          filter={{ ...filter, ...pagination }}
          setValues={setPagination}
          skip={pagination.skip || 0}
          NoData={View}
        />
      </Card>
    </>
  );
};

export default List;
